module.exports = __webpack_public_path__ + "img/witchinfest.74776a02.jpg";